import { inject, ref } from "vue";
import {
    updateShippingOption as updateShippingOptionRequest,
    updateShippingRegion as updateShippingRegionRequest,
} from "../api/shipping";

export function useShippingOption() {
    const emitter = inject<any>("mitt");
    const loading = ref(false);

    function updateShippingOption(shippingTimeId: number) {
        if (loading.value) {
            return;
        }

        loading.value = true;

        updateShippingOptionRequest(shippingTimeId)
            .then((data) => {
                emitter.emit("shippingOptionUpdated", {
                    shippingTimeId: shippingTimeId,
                    ...data,
                });
            })
            .catch((error) => {
                if (
                    typeof error.response !== "undefined" &&
                    Object.prototype.hasOwnProperty.call(
                        error.response,
                        "data",
                    ) &&
                    Object.prototype.hasOwnProperty.call(
                        error.response.data,
                        "errors",
                    )
                ) {
                    emitter.emit("shippingOptionError", {
                        data: error.response.data,
                    });
                }
            })
            .finally(() => (loading.value = false));
    }

    function updateShippingRegion(inputs: any) {
        if (loading.value) {
            return;
        }

        loading.value = true;

        updateShippingRegionRequest(inputs)
            .then((data) => {
                emitter.emit("shippingRegionUpdated", data);
            })
            .catch((error) => {
                if (
                    typeof error.response !== "undefined" &&
                    Object.prototype.hasOwnProperty.call(
                        error.response,
                        "data",
                    ) &&
                    Object.prototype.hasOwnProperty.call(
                        error.response.data,
                        "errors",
                    )
                ) {
                    emitter.emit("shippingRegionError", {
                        data: error.response.data,
                    });
                }
            })
            .finally(() => (loading.value = false));
    }

    return {
        loading,
        updateShippingOption,
        updateShippingRegion,
    };
}
